import React, { useEffect, useState, useRef } from "react";

import ReactQuill, { Quill } from "react-quill";
import QuillImageDropAndPaste from "quill-image-drop-and-paste";
import QuillEmoji from "quill-emoji";
import QuillMention from "quill-mention";
// import ImageResize from "quill-image-resize-module";
// import ImageDrop from "quill-image-drop-module";
import * as _ from "lodash";
import "./QuillAttachment";
import { Select, notification } from "antd";
import "react-quill/dist/quill.snow.css";
import "quill-emoji/dist/quill-emoji.css";
// const Delta = Quill.import('delta');
import "./style.scss";
import {
  ProjectUser,
  TestCase,
  Company,
  UploadsApi
} from "../../../services/generated-sdk";
import { Modal } from "antd";
import { downloadLink } from "../../../utils/common";
import UploadDragger from "../UploadDragger";

const CustomButton = () => <span className="octicon octicon-star" />;

export default function QuillEditor({
  onChange,
  value,
  placeholder,
  height,
  projectUsers = [],
  setAttachments = () => {},
  setMentions = () => {},
  limit = 50000000,
  testCases,
  defaultValue = "",
  supportEmoji = true,
  width,
  company,
  autoFocus = false,
  hideToolbarOptions = [],
  updateOnBlur = false,
  testParameters = []
}: Props): JSX.Element {
  injectQuillExtensions(updateOnBlur);
  let quill = useRef<ReactQuill>();
  const [hideToolbar, setHideToolbar] = useState<boolean>(false);
  const [showUploader, setShowUploader] = useState<boolean>(false);
  const [loadingImages, setImageLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>("");
  const [files, setFiles] = useState([]);
  const [processedFiles, setProcessedFiles] = useState([]);
  const [editorContent, setEditorContent] = useState(null);
  const [showTestParametersList, setShowTestParametersList] = useState<boolean>(
    false
  );
  const imageHandler = () => {
    setShowUploader(true);
  };

  // let toolbarContainerOptions = [
  //   ["bold", "italic", "underline"],
  //   [{ list: "ordered" }, { list: "bullet" }],
  //   [{ indent: "-1" }, { indent: "+1" }],
  //   [{ color: [] }, { background: [] }],
  //   // [{ 'font': [] }],
  //   // [{ align: [] }],
  //   ["clean"],
  //   ["image"],
  //   [supportEmoji ? "emoji" : undefined]
  // ];

  let toolbarContainerOptions = [];
  toolbarContainerOptions.push(["bold", "italic", "underline"]);
  if (hideToolbarOptions && hideToolbarOptions.length) {
    if (!hideToolbarOptions.includes("list")) {
      toolbarContainerOptions.push([{ list: "ordered" }, { list: "bullet" }]);
    }
    if (!hideToolbarOptions.includes("indent")) {
      toolbarContainerOptions.push([{ indent: "-1" }, { indent: "+1" }]);
    }
    if (!hideToolbarOptions.includes("color")) {
      toolbarContainerOptions.push([{ color: [] }, { background: [] }]);
    }
    if (!hideToolbarOptions.includes("clean")) {
      toolbarContainerOptions.push(["clean"]);
    }
    if (!hideToolbarOptions.includes("link")) {
      toolbarContainerOptions.push(["link"]);
    }
  } else {
    toolbarContainerOptions.push([{ list: "ordered" }, { list: "bullet" }]);
    toolbarContainerOptions.push([{ indent: "-1" }, { indent: "+1" }]);
    toolbarContainerOptions.push([{ color: [] }, { background: [] }]);
    toolbarContainerOptions.push(["clean"]);
    toolbarContainerOptions.push(["link"]);
  }
  if (
    !(
      hideToolbarOptions &&
      hideToolbarOptions.length &&
      hideToolbarOptions.includes("image")
    )
  ) {
    toolbarContainerOptions.push(["image"]);
  }
  if (supportEmoji) {
    toolbarContainerOptions.push(["emoji"]);
  }
  if (
    testParameters &&
    testParameters.length &&
    (!hideToolbarOptions ||
      (hideToolbarOptions && !hideToolbarOptions.includes("video")))
  ) {
    toolbarContainerOptions.push(["custom"]);
    // toolbarContainerOptions.push(["video"]);
  }

  async function imageHandler2(imageDataUrl, type, imageData, callback?) {
    if (loadingImages) {
      console.log("Already loading images...");
      return;
    }
    try {
      setImageLoading(true);
      // const blob = imageData.toBlob();
      const file = imageData.toFile();
      const upApi = new UploadsApi();

      const uploadData = await upApi.createUpload({
        files: file,
        company: company && company.id ? company.id : null
      });

      if (uploadData && uploadData.length && uploadData[0].id) {
        setFiles(uploadData.concat(files));
        const current: any = quill.current;
        if (current) {
          const editor = current.getEditor();
          let range = editor.getSelection(editor);

          uploadData.forEach((attachment, index) => {
            if (index > 0)
              editor.insertText(
                range.index ? range.index + 1 : 0,
                " ",
                "<br /><br />"
              );
            range = editor.getSelection(editor);

            editor.insertEmbed(
              range.index ? range.index + 1 : 0,
              "attachment",
              JSON.stringify({
                link: downloadLink(attachment, company),
                name: `${attachment.name}`,
                ext: attachment.ext
              })
            );
          });

          setTimeout(() => {
            editor.insertText(
              range.index ? range.index + 5 : 0,
              " ",
              "<br /><br />"
            );
            range = editor.getSelection(editor);
            editor.setSelection(range.index ? range.index + 2 : 2);
          }, 100);
        }
      } else {
        console.log({ upload_failed: uploadData });
      }
      setImageLoading(false);
      // upload image to your server
      // callUploadAPI(your_upload_url, formData, (err, res) => {
      //   if (err) return
      //   // success? you should return the uploaded image's url
      //   // then insert into the quill editor
      //   let index = (quill.getSelection() || {}).index;
      //   if (index === undefined || index < 0) index = quill.getLength();
      //   quill.insertEmbed(index, 'image', res.data.image_url, 'user')
      // })
    } catch (e) {
      console.log({ error_in_image_parse: e.message });
      setImageLoading(false);
    }
  }

  const [properties, setProperties] = useState<any>({
    modules: {
      mention: {
        allowedChars: /^[A-Za-z0-9_\-\^$.|?*+() ]*$/,
        mentionDenotationChars: ["@", "#", "{"],
        // defaultMenuOrientation: "top",
        linkTarget: "_blank",
        dataAttributes: ["email"],
        mentionListClass:
          height && height == "100px"
            ? "ql-mention-list-small"
            : "ql-mention-list",
        listItemClass: "ql-mention-list-item",
        source: async function(searchTerm, renderList, mentionChar) {
          let values;

          if (mentionChar === "@") {
            values = projectUsers;
          } else if (mentionChar === "#") {
            values = testCases;
          } else {
            values = testParameters.map(tp => {
              return { id: tp, value: tp };
            });
          }

          if (searchTerm.length === 0) {
            renderList(values, searchTerm);
          } else {
            const matches = [];
            for (let i = 0; i < values.length; i++) {
              if (
                ~values[i].value.toLowerCase().indexOf(searchTerm.toLowerCase())
              )
                matches.push(values[i]);
            }
            renderList(matches, searchTerm);
          }
        }
      },
      toolbar: {
        // container: [
        //   ["bold", "italic", "underline"],
        //   [{ list: "ordered" }, { list: "bullet" }],
        //   [{ indent: "-1" }, { indent: "+1" }],
        //   [{ color: [] }, { background: [] }],
        //   // [{ 'font': [] }],
        //   // [{ align: [] }],
        //   ["clean"],
        //   ["image"],
        //   [supportEmoji ? "emoji" : undefined]
        // ],
        container: toolbarContainerOptions,
        handlers: {
          image: imageHandler,
          // video: function (value) {
          //   setShowTestParametersList(!showTestParametersList);
          // },
          custom: function(value) {
            setShowTestParametersList(!showTestParametersList);
            // console.log({ value });
            // let paramToInsert = "{{TEST_PARAMETER}}";
            // const current: any = quill.current;
            // if (current) {
            //   console.log("now insert test parameter...");
            //   const editor = current.getEditor();
            //   let cursorPosition = editor.getSelection(editor).index;
            //   editor.insertText(cursorPosition, paramToInsert);
            //   editor.setSelection(cursorPosition + paramToInsert.length);
            // }
            // // const cursorPosition = this.quill.getSelection().index;
            // // this.quill.insertText(cursorPosition, '★');
            // // this.quill.setSelection(cursorPosition + 1);
          }
        }
      },
      "emoji-toolbar": supportEmoji,
      "emoji-textarea": false,
      "emoji-shortname": supportEmoji,
      clipboard: { matchVisual: true },
      imageDropAndPaste: {
        // add an custom clipboard image paste handler
        handler: imageHandler2
      }
      // imageResize: updateOnBlur ? false : { displaySize: true }
    },
    formats: [
      "bold",
      "italic",
      "underline",
      "list",
      "bullet",
      "attachment",
      "emoji",
      "indent",
      "direction",
      "align",
      "color",
      "background",
      "link"
    ]
  });

  useEffect(
    () => {
      if (!editorContent && updateOnBlur) {
        let initialVal = null;
        if (value && value.length) {
          setEditorContent(value);
          initialVal = value;
        } else if (defaultValue && defaultValue.length) {
          initialVal = defaultValue;
        }
        if (onChange != undefined && initialVal && initialVal.length) {
          onChange(initialVal);
        }
      }
      // if(supportEmoji){
      //   const withEmojis = [...properties.modules.toolbar.container, ['emoji']];

      // }
      if (
        value &&
        value.length > 0 &&
        (value.toString().includes("@") || value.toString().includes("#"))
      ) {
        setProperties({
          modules: {
            ...properties.modules,
            mention: {
              ...properties.modules.mention
            }
          }
        });
      }

      if (quill) {
        const current: any = quill.current;
        if (current && autoFocus) {
          const editor = current.getEditor();
          if (autoFocus) editor.focus();
          // console.log("quill found......................");
          // try {
          //   // quill.keyboard.addBinding({ key: 'B', shiftKey: null }, handler);
          //   // quill.current.getEditor().clipboard.dangerouslyPasteHTML("<div><b>TESTING...................</b></div>");
          //   // quill.current.getEditor().keyboard.addBinding({ key: "v", shortKey: true }, test1);
          //   quill.current.getEditor().clipboard.addMatcher('V', function (node, delta) {
          //     return delta.compose(new Delta().retain(delta.length(), { bold: true }));
          //   });
          // } catch (e) {
          //   console.log({ quill_err: e });
          // }
        }
      }
    },
    [value]
  );
  const uploadImage = async () => {
    const current: any = quill.current;
    if (current) {
      const editor = current.getEditor();
      let range = editor.getSelection(editor);

      let newFilesProcessed = [];
      files.forEach((attachment, index) => {
        if (processedFiles.length && processedFiles.includes(attachment.id)) {
          console.log("Already processed this file...", attachment, index);
          return;
        }
        newFilesProcessed.push(attachment.id);
        if (index > 0)
          editor.insertText(
            range.index ? range.index + 1 : 0,
            " ",
            "<br /><br />"
          );
        range = editor.getSelection(editor);
        editor.insertEmbed(
          range.index ? range.index + 1 : 0,
          "attachment",
          JSON.stringify({
            link: downloadLink(attachment, company),
            name: `${attachment.name}`,
            ext: attachment.ext
          })
        );
      });
      setTimeout(() => {
        editor.insertText(
          range.index ? range.index + 5 : 0,
          " ",
          "<br /><br />"
        );
        range = editor.getSelection(editor);
        editor.setSelection(range.index ? range.index + 2 : 2);
      }, 100);
      setProcessedFiles(newFilesProcessed.concat(processedFiles));
    }
    setShowUploader(false);
    return;
  };

  const wrapperStyle = {
    // height: !!height ? height : "105px",
    width: !!width! ? width : "100%",
    color: "#000",
    margin: "0 0"
  };

  const onTextChange = event => {
    const current: any = quill.current;
    if (current) {
      //@todo - firefox - handle large image paste which was skipped by image paste plugin
      // if (event && event.length) {
      //   //  <img src=\"data:image/png;base64,
      //   // /(<img src="([^\\"]+)" \\/>)/'
      // }

      if (updateOnBlur) {
        setEditorContent(event);
      }
      const editor = current.getEditor();
      if (limit <= event.length) {
        setError(`Maximum limit reached (${limit})`);
        try {
          notification.error({
            message: `Maximum limit reached (${limit}). Clearing Editor.`
          });
          quill.current.getEditor().deleteText(0, event.length);
        } catch (e) {
          console.log({ delete_editor_text_error: e });
        }
        // editor.deleteText(limit, editor.getLength());
        // if (!updateOnBlur) {
        //   onChange(event);
        // }
        return;
      } else {
        setError("");
        if (!updateOnBlur) {
          onChange(event);
        }
      }
      // if (limit <= editor.getLength()) {
      //   setError(`Maximum limit reached (${limit})`);
      //   editor.deleteText(limit, editor.getLength());
      //   if (!updateOnBlur) {
      //     onChange(event);
      //   }
      //   return;
      // } else {
      //   setError("");
      //   if (!updateOnBlur) {
      //     onChange(event);
      //   }
      // }
    }
  };

  const onBlur = (previousRange, source, editor) => {
    if (updateOnBlur) {
      onChange(editorContent);
    }
    // setHideToolbar(true);
    if (quill && quill.current && quill.current["editingArea"]) {
      const quillContainer = quill.current["editingArea"];

      const mentions = [];
      if (quillContainer) {
        const elems = quillContainer.getElementsByClassName("mention");
        for (let index = 0; index < elems.length; index++) {
          const element = elems[index];
          const denotationChar = element.getAttribute("data-denotation-char");
          if (denotationChar == "@") {
            const id = element.getAttribute("data-id");
            mentions.push(id);
          }
        }
      }

      if (setMentions) setMentions(mentions);
    }
  };
  return (
    <div style={wrapperStyle}>
      <div className={`quill-editor ${hideToolbar ? "toolbar-hidden" : ""}`}>
        {updateOnBlur ? (
          <ReactQuill
            theme="snow"
            ref={quill}
            onFocus={() => setHideToolbar(false)}
            onBlur={onBlur}
            onChange={onTextChange}
            defaultValue={defaultValue || value}
            modules={{
              toolbar: {}
              // ...properties.modules
            }}
            // formats={properties.formats}
            placeholder={!!placeholder ? placeholder : ""}
            style={wrapperStyle}
          />
        ) : (
          <ReactQuill
            theme="snow"
            ref={quill}
            onFocus={() => setHideToolbar(false)}
            onBlur={onBlur}
            onChange={onTextChange}
            defaultValue={defaultValue || value}
            modules={{
              ...properties.modules
            }}
            // formats={properties.formats}
            placeholder={!!placeholder ? placeholder : ""}
            style={wrapperStyle}
            value={!!value ? value : ""}
          />
        )}
        <Modal
          title="Upload File"
          visible={showUploader}
          onOk={uploadImage}
          okButtonProps={{ loading: loadingImages }}
          destroyOnClose
          onCancel={() => {
            setShowUploader(false);
          }}
        >
          <UploadDragger
            setFileList={setAttachments}
            setFiles={newfiles => setFiles(newfiles.concat(files))}
            setImageLoading={setImageLoading}
          />
        </Modal>
        {showTestParametersList ? (
          <Modal
            title="Insert Test Parameter"
            visible={showTestParametersList}
            onCancel={() => {
              setShowTestParametersList(false);
            }}
            footer={null}
            destroyOnClose
            // onOk={() => {
            //   setShowTestParametersList(false);
            // }}
            // onCancel={() => {
            //   setShowTestParametersList(false);
            // }}
          >
            <Select
              style={{ width: 300 }}
              onChange={value => {
                if (value && value.toString().length) {
                  let paramToInsert = "{{" + value.toString() + "}}";
                  const current: any = quill.current;
                  if (current) {
                    const editor = current.getEditor();
                    let cursorPosition = editor.getSelection(editor).index;
                    editor.insertText(cursorPosition, paramToInsert);
                    editor.setSelection(cursorPosition + paramToInsert.length);
                  }
                }
                setShowTestParametersList(false);
              }}
            >
              {testParameters.map((tp, tpIndx) => {
                return (
                  <Select.Option key={tp} value={tp}>
                    {tp}
                  </Select.Option>
                );
              })}
            </Select>
          </Modal>
        ) : null}
      </div>
      <span className="text-err">{error}</span>
    </div>
  );
}

const injectQuillExtensions = function(updateOnBlur) {
  let extensionsToAdd = {};
  extensionsToAdd["formats/emoji"] = QuillEmoji.EmojiBlot;
  extensionsToAdd["modules/emoji-toolbar"] = QuillEmoji.ToolbarEmoji;
  extensionsToAdd["modules/emoji-textarea"] = QuillEmoji.TextAreaEmoji;
  extensionsToAdd["modules/emoji-shortname"] = QuillEmoji.ShortNameEmoji;
  extensionsToAdd["modules/mention"] = QuillMention;
  if (!updateOnBlur) {
    // extensionsToAdd["modules/imageResize"] = ImageResize;
  }
  extensionsToAdd["modules/imageDropAndPaste"] = QuillImageDropAndPaste;

  Quill.register(extensionsToAdd, true);
  // Quill.register(
  //   {
  //     "formats/emoji": QuillEmoji.EmojiBlot,
  //     "modules/emoji-toolbar": QuillEmoji.ToolbarEmoji,
  //     "modules/emoji-textarea": QuillEmoji.TextAreaEmoji,
  //     "modules/emoji-shortname": QuillEmoji.ShortNameEmoji,
  //     "modules/mention": QuillMention,
  //     "modules/imageResize": ImageResize
  //     // "modules/imageDrop": ImageDrop
  //   },
  //   true
  // );
};

interface Props {
  onChange?: (text: string) => void;
  value?: string;
  defaultValue?: string;
  placeholder?: string;
  height?: string;
  supportEmoji?: boolean;
  width?: string;
  projectUsers?: ProjectUser[];
  testCases?: TestCase[];
  limit?: number;
  setAttachments?: (attachments: []) => void;
  setMentions?: (mentions?: string[]) => void;
  company: Company;
  autoFocus?: boolean;
  hideToolbarOptions?: string[];
  updateOnBlur?: boolean;
  testParameters?: string[];
}
